import { useMutation } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'

export interface EnterpriseBusinessImportCancelParams {
  enterpriseId: number
  uploadId: string
}

export interface EnterpriseBusinessImportCancelResponse {
  success: boolean
  uploadId: string
  status: 'cancelled'
}

/**
 * Cancel a staged enterprise business import before it is processed.
 */
const cancelEnterpriseBusinessImport = async ({ enterpriseId, uploadId }: EnterpriseBusinessImportCancelParams) => {
  return postRequest<EnterpriseBusinessImportCancelResponse>(
    `/enterprise/${enterpriseId}/business-import/${uploadId}/cancel`,
  )
}

export default function useEnterpriseBusinessImportCancel() {
  return useMutation({
    mutationFn: async (params: EnterpriseBusinessImportCancelParams) => {
      const response = await cancelEnterpriseBusinessImport(params)

      if (!response) {
        throw new Error('No response received from enterprise business import cancel')
      }

      return response
    },
  })
}
